import css from "./QuestLink.module.css";

import { Link } from "react-router";
import { GameVer, tturl, useRealm } from "~/util/Lang";

export type QuestLinkData = {
  id: number;
  uname: string;
  name: string;
  gver?: GameVer;
};

const questLinkColor = "#4ab34a";

export function getQuestPath(props: { quest: QuestLinkData }) {
  const quest = props.quest;
  const realm = useRealm();

  return tturl(
    { lang: realm.lang, game: quest.gver ?? realm.game },
    `/quests/${quest.uname}`
  );
}

export function QuestIcon() {
  return (
    <img src="/s/ui/icons/quest3.png" width={16} height={16} alt="Quest Icon" />
  );
}

export function QuestLink(props: { quest: QuestLinkData; isLink?: boolean }) {
  const quest = props.quest;
  const isLink = props.isLink ?? true;

  const linkContent = (
    <>
      <span
        style={{
          display: "inline-block",
          verticalAlign: "middle",
          marginRight: 4,
        }}
      >
        <QuestIcon />
      </span>
      {quest.name}
    </>
  );

  return (
    <span style={{}}>
      {isLink ? (
        <Link to={getQuestPath({ quest })} className={css.link}>
          {linkContent}
        </Link>
      ) : (
        <span className={css.link}>{linkContent}</span>
      )}
    </span>
  );
}
